module.exports = __webpack_public_path__ + "static/img/8.7066853.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/7/zh/8.png
// module id = m0Nf
// module chunks = 0